<div class="testBox shimmer" *ngIf="!shim">

</div>
<img [src]="src" class="testBox" [class.d-none]="!shim" [class.d-none]="initial" (load)="shim=true"
    (error)="errorImg($event)" [style]="'border-radius:'+border_radius+';'">
<span *ngIf="profilePic" [class.d-none]="!initial"
    [ngStyle]="{'font-size':fontSize,'border-radius':border_radius,'background':background_color,'color':span_color}">{{initials}}</span>
<!-- [style]="'font-size:'+fontSize+';' +'border-radius:'+border_radius+';'+'background:'+background_color+';'+'color'+span_color+';'" -->